export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  // If a worker is ALREADY controlling this page (a returning visitor), reload
  // once the moment a new worker activates and takes control. Combined with the
  // service worker's skipWaiting()/clients.claim(), this means a fresh deploy
  // reaches returning users automatically instead of leaving them on a stale
  // cached shell. New visitors (no controller yet) skip this — no reload churn.
  if (navigator.serviceWorker.controller) {
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      // updateViaCache: 'none' forces the browser to always hit the network when
      // checking /sw.js for a new version, so an updated worker is never masked
      // by a cached copy of the script.
      .register('/sw.js', { updateViaCache: 'none' })
      .then((registration) => {
        console.log('SW registered:', registration.scope);
        // Check for a new worker immediately on load, then hourly.
        registration.update();
        setInterval(() => registration.update(), 60 * 60 * 1000);
      })
      .catch((error) => {
        console.error('SW registration failed:', error);
      });
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
